"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EDSContext = require("../../EDSContext/EDSContext");
var _styles = _interopRequireDefault(require("../../styles"));
var _core = require("@ellucian/react-design-system/core");
var _tokens = require("../../styles/tokens");
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = function styles(theme) {
  return {
    contentPadding: {
      paddingBottom: _tokens.spacing40
    },
    paper: {
      width: theme.spacing(100) // 400 px
    },
    popperTitle: {
      fontSize: theme.typography.h4.fontSize,
      fontWeight: theme.typography.h4.fontWeight,
      marginBottom: _tokens.spacing40
    },
    popperActions: {
      textAlign: 'right',
      '& button:not(:last-child)': {
        marginRight: _tokens.spacing40
      }
    }
  };
};
var ImagePopper = function ImagePopper(props) {
  var _containerRef$current, _containerRef$current2;
  var classes = props.classes,
    edsContext = props.edsContext,
    url = props.url,
    altText = props.altText,
    linkUrl = props.linkUrl,
    linkTarget = props.linkTarget,
    isPopperOpen = props.isPopperOpen,
    _props$isEdit = props.isEdit,
    isEdit = _props$isEdit === void 0 ? false : _props$isEdit,
    disableLinkTargets = props.disableLinkTargets,
    onInsertImage = props.onInsertImage,
    onClose = props.onClose,
    containerRef = props.containerRef;
  var _useState = (0, _react.useState)({
      url: url != null ? url : '',
      altText: altText != null ? altText : '',
      linkUrl: linkUrl != null ? linkUrl : '',
      linkTarget: linkTarget != null ? linkTarget : ''
    }),
    image = _useState[0],
    setImage = _useState[1];
  var _useState2 = (0, _react.useState)(''),
    urlError = _useState2[0],
    setUrlError = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    linkUrlError = _useState3[0],
    setLinkUrlError = _useState3[1];
  var urlHelperMessage = edsContext.formatMessage('component.RichTextEditor.imagePopperURLHelper');
  var urlInvalidMessage = edsContext.formatMessage('component.RichTextEditor.invalidURL');
  var _useState4 = (0, _react.useState)(linkUrl !== '' || linkTarget !== ''),
    checked = _useState4[0],
    setChecked = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    dropdownOpen = _useState5[0],
    setDropdownOpen = _useState5[1];
  var dropdownInputRef = (0, _react.useRef)();
  var _useState6 = (0, _react.useState)((_containerRef$current = containerRef == null || (_containerRef$current2 = containerRef.current) == null ? void 0 : _containerRef$current2.querySelector('button.ql-image')) != null ? _containerRef$current : document.querySelector('button.ql-image')),
    imagePopperAnchor = _useState6[0],
    setImagePopperAnchor = _useState6[1];
  var saveButtonRef = (0, _react.useRef)();
  var urlInputRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (isPopperOpen) {
      setUrlError('');
      setLinkUrlError('');
    }
  }, [isPopperOpen]);
  (0, _react.useEffect)(function () {
    var _containerRef$current3, _containerRef$current4;
    setImage({
      url: url,
      altText: altText,
      linkUrl: linkUrl,
      linkTarget: linkTarget
    });
    setImagePopperAnchor((_containerRef$current3 = containerRef == null || (_containerRef$current4 = containerRef.current) == null ? void 0 : _containerRef$current4.querySelector('button.ql-image')) != null ? _containerRef$current3 : document.querySelector('button.ql-image'));
    setChecked(linkUrl !== '' || linkTarget !== '');
  }, [containerRef, url, altText, linkUrl, linkTarget]);
  var handleUrlChange = (0, _react.useCallback)(function (urlValue) {
    // disable the helper text when text is inputted
    if (urlError && urlValue) {
      setUrlError('');
    }
    setImage(function (prevImage) {
      return (0, _extends2.default)({}, prevImage, {
        url: urlValue
      });
    });
  }, [urlError]);
  var handleAltTextChange = (0, _react.useCallback)(function (altTextValue) {
    setImage(function (prevImage) {
      return (0, _extends2.default)({}, prevImage, {
        altText: altTextValue
      });
    });
  }, []);
  var handleCheckboxChange = function handleCheckboxChange(event) {
    setChecked(event.target.checked);
  };
  var handleLinkUrlChange = (0, _react.useCallback)(function (linkUrl) {
    // disable the helper text when text is inputted
    if (linkUrlError && linkUrl) {
      setLinkUrlError('');
    }
    setImage(function (prevImage) {
      return (0, _extends2.default)({}, prevImage, {
        linkUrl: linkUrl
      });
    });
  }, [linkUrlError]);
  var handleLinkTargetChange = (0, _react.useCallback)(function (targetValue) {
    setImage(function (prevLink) {
      return (0, _extends2.default)({}, prevLink, {
        linkTarget: targetValue
      });
    });
  }, []);

  // closes the dropdown and returns focus to the dropdown input field
  var handleDropdownClose = function handleDropdownClose() {
    setDropdownOpen(false);
    // focuses the dropdown input after the next event cycle i.e. after the dropdown is closed
    setTimeout(function () {
      dropdownInputRef.current.focus();
    });
  };

  // fires the onInsertImage prop function and closes the popper if url is present
  var handleInsertImage = (0, _react.useCallback)(function () {
    // check if the image url exists and is a valid url
    if (image.url === '') {
      setUrlError(urlHelperMessage);
      return;
    } else if (!(0, _utils.validateURL)(image.url)) {
      setUrlError(urlInvalidMessage);
      return;
    } else if (!checked) {
      onInsertImage({
        url: image.url.trim(),
        altText: image.altText
      });
      setChecked(false);
      setImage({
        url: '',
        altText: '',
        linkUrl: '',
        linkTarget: ''
      });
    }

    // check if the link url exists and is a valid url
    if (checked) {
      var validLinkUrl = (0, _utils.validateURL)(image.linkUrl);
      if (image.linkUrl === '') {
        setLinkUrlError(urlHelperMessage);
        return;
      } else if (!validLinkUrl) {
        setLinkUrlError(urlInvalidMessage);
        return;
      } else {
        onInsertImage({
          url: image.url.trim(),
          altText: image.altText,
          linkUrl: image.linkUrl.trim(),
          linkTarget: image.linkTarget
        });
        setChecked(false);
        setImage({
          url: '',
          altText: '',
          linkUrl: '',
          linkTarget: ''
        });
      }
    }
  }, [image, onInsertImage, urlHelperMessage, urlInvalidMessage, checked]);
  var handleCancelImage = (0, _react.useCallback)(function () {
    if (!dropdownOpen) {
      onClose();
      setChecked(false);
      setImage({
        url: '',
        altText: '',
        linkUrl: '',
        linkTarget: ''
      });
    }
  }, [onClose, dropdownOpen]);

  // traps and wraps the focus within the popper
  var wrapFocus = function wrapFocus(e) {
    // ignore key-presses that are not tabs
    if (!(e.key === 'Tab')) {
      return;
    }
    if (document.activeElement === saveButtonRef.current && !e.shiftKey) {
      // focus start input
      e.preventDefault();
      urlInputRef.current.focus();
    }
    if (document.activeElement === urlInputRef.current && e.shiftKey) {
      // focus save button
      e.preventDefault();
      saveButtonRef.current.focus();
    }
  };

  // allows the user to press escape to close the popper
  var escapePopper = function escapePopper(e) {
    if (e.key === 'Escape') {
      handleCancelImage();
    }
  };
  var stringOptions = [{
    value: '_self',
    label: '_self'
  }, {
    value: '_blank',
    label: '_blank'
  }, {
    value: '_parent',
    label: '_parent'
  }, {
    value: '_top',
    label: '_top'
  }];
  return /*#__PURE__*/_react.default.createElement(_core.Popper, {
    id: "RTE_imagePopper",
    role: "alertdialog",
    open: isPopperOpen,
    onClickAway: handleCancelImage,
    onClose: onClose,
    classes: {
      paperRoot: classes.paper
    },
    title: isEdit ? edsContext.formatMessage('component.RichTextEditor.imagePopperTitleEdit') : edsContext.formatMessage('component.RichTextEditor.imagePopperTitleAdd'),
    TitleTypographyProps: {
      classes: {
        root: classes.popperTitle
      }
    },
    anchorEl: imagePopperAnchor,
    placement: edsContext.dir === 'ltr' ? 'bottom-start' : 'bottom-end',
    onKeyDown: function onKeyDown(e) {
      return escapePopper(e);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentPadding
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    "data-id": "imagePopperURL",
    label: edsContext.formatMessage('component.RichTextEditor.imagePopperURL'),
    onChange: function onChange(e) {
      return handleUrlChange(e.target.value);
    },
    type: "text",
    value: image.url,
    fullWidth: true
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: true,
    onKeyDown: function onKeyDown(e) {
      return wrapFocus(e);
    },
    inputRef: urlInputRef,
    error: urlError !== '',
    helperText: urlError,
    required: true
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    "data-id": "imagePopperAltText",
    label: edsContext.formatMessage('component.RichTextEditor.imagePopperAltText'),
    onChange: function onChange(e) {
      return handleAltTextChange(e.target.value);
    },
    type: "text",
    value: image.altText,
    fullWidth: true
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    label: edsContext.formatMessage('component.RichTextEditor.imagePopperAddLink'),
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: checked,
      onChange: function onChange(e) {
        return handleCheckboxChange(e);
      }
    })
  })), checked && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentPadding
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    "data-id": "imagePopperLinkUrl",
    label: edsContext.formatMessage('component.RichTextEditor.linkPopperLink'),
    onChange: function onChange(e) {
      return handleLinkUrlChange(e.target.value);
    },
    type: "text",
    value: image.linkUrl,
    fullWidth: true,
    error: linkUrlError !== '',
    helperText: linkUrlError,
    required: true
  })), !disableLinkTargets && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentPadding
  }, /*#__PURE__*/_react.default.createElement(_core.Dropdown, {
    "data-id": "imagePopperLinkTarget",
    value: image.linkTarget,
    label: edsContext.formatMessage('component.RichTextEditor.linkPopperTarget'),
    onChange: function onChange(e) {
      return handleLinkTargetChange(e.target.value);
    },
    onOpen: function onOpen() {
      return setDropdownOpen(true);
    },
    onClose: handleDropdownClose,
    open: dropdownOpen,
    fullWidth: true
    // prevents the window from scrolling to the top of the page when a dropdown item is selected
    ,
    MenuProps: {
      disableRestoreFocus: true
    },
    inputRef: dropdownInputRef
  }, stringOptions.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_core.DropdownItem, {
      key: option.value,
      label: option.label,
      value: option.value
    });
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.popperActions
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    "data-id": "imagePopperCancel",
    onClick: handleCancelImage,
    color: "secondary",
    "aria-label": edsContext.formatMessage('component.RichTextEditor.cancel')
  }, edsContext.formatMessage('component.RichTextEditor.cancel')), /*#__PURE__*/_react.default.createElement(_core.Button, {
    "data-id": "imagePopperSave",
    onClick: handleInsertImage,
    color: "primary",
    "aria-label": edsContext.formatMessage('component.RichTextEditor.save'),
    onKeyDown: function onKeyDown(e) {
      return wrapFocus(e);
    },
    ref: saveButtonRef
  }, edsContext.formatMessage('component.RichTextEditor.save'))));
};
ImagePopper.propTypes = {
  /**
   * @ignore
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * Ref to the parent RichTextEditor container.
   * @ignore
  */
  containerRef: _propTypes.default.object,
  /**
  * Initial value for url text value
  */
  url: _propTypes.default.string,
  /**
  * Initial value for the alt text value
  */
  altText: _propTypes.default.string,
  /**
  * Initial value for the link url
  */
  linkUrl: _propTypes.default.string,
  /**
  * Initial value for the link target
  */
  linkTarget: _propTypes.default.string,
  /**
  * Indicates if the Popper should open or close
  */
  isPopperOpen: _propTypes.default.bool,
  /**
  * Indicates if the Popper's title should be edit or add
  */
  isEdit: _propTypes.default.bool,
  /**
   * If `true`, the `target` dropdown will be hidden
  */
  disableLinkTargets: _propTypes.default.bool,
  /**
  * Callback fired when the save button is clicked
  * `@param {object} image`   The image with url and alt text to insert
  *
  */
  onInsertImage: _propTypes.default.func.isRequired,
  /**
   * Callback fired when the cancel button is clicked
   */
  onClose: _propTypes.default.func.isRequired,
  /**
  * Initial value for the title text value
  */
  title: _propTypes.default.string,
  /**
  * Initial value for the target dropdown value
  */
  target: _propTypes.default.string
};
var _default = exports.default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(ImagePopper));